module.exports = __webpack_public_path__ + "static/media/kmlMark.ad8e91c3.png";